import type {
  NonProspectDomainsUpdateDto,
  NonProspectDomainsViewDto,
} from '@/types/nonProspectDomains'
import { apiClient, type ApiResponse } from './client'

/**
 * Non-prospect email domains (ORB-619). Two sub-resources returning the same shape — the standing
 * set on a client company and the per-workspace set — so one editor component drives both.
 * Deliberately separate from `/Tracking`, which carries the visitor-tracking origin allowlist.
 */
export const nonProspectDomainsApi = {
  getForCompany: (clientCompanyId: string): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/NonProspectDomains`),

  patchForCompany: (
    clientCompanyId: string,
    dto: NonProspectDomainsUpdateDto,
  ): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.patch(`/api/ClientCompanies/${clientCompanyId}/NonProspectDomains`, dto),

  getForWorkspace: (
    clientCompanyId: string,
    workspaceId: string,
  ): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/NonProspectDomains`),

  patchForWorkspace: (
    clientCompanyId: string,
    workspaceId: string,
    dto: NonProspectDomainsUpdateDto,
  ): Promise<ApiResponse<NonProspectDomainsViewDto>> =>
    apiClient.patch(`/api/ClientCompanies/${clientCompanyId}/Workspaces/${workspaceId}/NonProspectDomains`, dto),
}
